import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  formBody: {
    backgroundColor: colors.neutral.white,
    borderRadius: '10px',
    margin: { bottom: '6.4rem', left: 'auto', right: 'auto' },
    padding: {
      top: '3.2rem',
      bottom: '3.6rem',
    },
    display: 'flex',
    justifyContent: 'center',
    minHeight: '10rem',
    position: 'relative',
  },
  disableTableBody: {
    cursor: 'not-allowed',
    '&::after': {
      position: 'absolute',
      content: "''",
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      backgroundColor: 'rgba(242,244,249, 0.3)',
      zIndex: 10,
    },
  },
  innerWrapper: {
    flex: '0 100 80%',
    '@media(max-width: 1124px)': {
      flexBasis: '90%',
    },
  },
  footer: { display: 'flex', justifyContent: 'center', marginBottom: '9.6rem' },
  saveButton: { marginRight: '1.6rem' },
  spinnerBg: { borderRadius: '0.6rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
